import React from "react";
import "./Terms.css";
import Footer from "../../components/Footer/Footer";

export default function Terms({ navigate, showComingSoon }) {
  return (
    <>
      <div className="terms-hero">
        <div className="terms-hero-inner">
          <div
            className="big-icon"
            style={{ background: "rgba(255,255,255,0.07)" }}
          >
            📋
          </div>
          <h1>Terms &amp; Conditions</h1>
          <p>Please read these terms carefully before using RoadDogg AI.</p>
        </div>
      </div>

      <div className="legal-body">
        <div className="legal-inner">
          <span
            style={{
              color: "#999",
              fontSize: "13px",
              marginBottom: "40px",
              display: "block",
            }}
          >
            Last updated: January 1, 2025
          </span>

          <h2>1. Acceptance of Terms</h2>
          <p>
            RoadDogg AI is a product of <strong>Kustom Habitz LLC</strong>. By
            downloading, installing, or using RoadDogg AI ("App"), you agree to
            be bound by these Terms and Conditions ("Terms") between you and
            Kustom Habitz LLC. If you do not agree to these Terms, do not use
            the App. These Terms apply to all users of the App, including free
            and premium subscribers.
          </p>

          <h2>2. Description of Service</h2>
          {/* description broadened to all users */}
          <p>
            RoadDogg AI is designed for all drivers, travelers, and everyday
            users looking for a smarter way to navigate, log, and stay informed
            on the road. The App provides AI-powered assistance, mapping and
            navigation, trip logging, weather information, and document
            management tools. Available on iOS and Android.
          </p>

          <h2>3. User Accounts</h2>
          <p>
            To access certain features of the App, you must create an account.
            You are responsible for:
          </p>
          <ul>
            <li>Maintaining the confidentiality of your account credentials</li>
            <li>All activities that occur under your account</li>
            <li>
              Notifying us immediately of any unauthorized use of your account
            </li>
            <li>
              Ensuring that your account information is accurate and up to date
            </li>
          </ul>
          {/* change #5 — account deletion for App Store compliance */}
          <p>
            Users may request deletion of their account and associated data
            directly within the App or by contacting support at
            kustomhabitzz@gmail.com.
          </p>

          <h2>4. Permitted Use</h2>
          <p>
            You may use RoadDogg AI for lawful, personal, and professional
            purposes. You agree not to:
          </p>
          <ul>
            <li>
              Use the App in any way that violates applicable laws or
              regulations
            </li>
            <li>
              Attempt to gain unauthorized access to any systems or networks
            </li>
            <li>
              Reproduce, distribute, or create derivative works from the App
              without permission
            </li>
            <li>
              Use automated tools, bots, or scrapers to extract data from the
              App
            </li>
            <li>
              Engage in any activity that disrupts or interferes with the App's
              operation
            </li>
          </ul>

          <h2>5. Subscriptions and Billing</h2>
          <p>
            RoadDogg AI offers both free and paid subscription tiers. Paid
            subscriptions are billed through the App Store (iOS) or Google Play
            (Android) and are subject to their respective terms. Subscriptions
            auto-renew unless cancelled at least 24 hours before the end of the
            current billing period.
          </p>
          {/* change #6 — updated refund wording */}
          <p>
            Refund requests are subject to the policies of the Apple App Store
            or Google Play Store. We do not independently process refunds for
            subscription purchases handled through those platforms.
          </p>

          <h2>6. RoadDogg AIant Disclaimer</h2>
          <p>
            The AI assistant within RoadDogg AI is designed to help users with
            general information and guidance. However:
          </p>
          <ul>
            <li>
              The AI may occasionally produce inaccurate, outdated, or
              incomplete information
            </li>
            <li>
              The AI is not a substitute for professional legal, safety, or
              regulatory advice
            </li>
            <li>
              Information about regulations, compliance requirements, or legal
              obligations should always be verified with official sources
            </li>
            <li>
              We are not liable for decisions made based on AI-generated
              inaccuracies or regulatory misstatements
            </li>
          </ul>
          {/* change #2 — emergency services disclaimer */}
          <p>
            <strong>Emergency Disclaimer:</strong> RoadDogg AI is not intended
            for emergency, medical, or life-critical situations. Do not rely on
            the App as your sole resource in any emergency. Always contact
            emergency services directly when safety is at risk.
          </p>

          <h2>7. Maps, Navigation &amp; Weather</h2>
          <p>
            The App uses third-party mapping services (Google Maps). Accuracy of
            map data, routing, and location information is subject to the terms
            and accuracy of those providers.
          </p>
          {/* change #3 — weather/routing accuracy disclaimer */}
          <p>
            <strong>Accuracy Disclaimer:</strong> Weather, traffic, routing, and
            location information may be delayed, incomplete, or inaccurate and
            should not be solely relied upon for safety-critical decisions.
            Third-party map, navigation, and weather inaccuracies are outside
            our control. You are solely responsible for your driving decisions
            and compliance with all applicable traffic laws.
          </p>

          <h2>8. Intellectual Property</h2>
          <p>
            All content, features, and functionality of the App — including but
            not limited to text, graphics, logos, icons, images, software, and
            source code — are the exclusive property of RoadDogg AI and are
            protected by applicable intellectual property laws. You may not
            copy, modify, distribute, sell, or lease any part of the App without
            our express written permission.
          </p>

          <h2>9. User Content</h2>
          <p>
            You retain ownership of all content you create within the App (logs,
            notes, documents). By using the App, you grant RoadDogg AI a
            limited, non-exclusive license to store, process, and display your
            content solely for the purpose of providing the service to you. We
            do not use your personal data for advertising purposes.
          </p>

          <h2>10. Disclaimers and Limitation of Liability</h2>
          <p>
            THE APP IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF
            ANY KIND, EXPRESS OR IMPLIED. TO THE MAXIMUM EXTENT PERMITTED BY
            LAW, ROADDOGG AI DISCLAIMS ALL WARRANTIES INCLUDING IMPLIED
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
            NON-INFRINGEMENT.
          </p>
          {/* change #7 — expanded liability to cover all inaccuracy types */}
          <p>
            IN NO EVENT SHALL ROADDOGG AI BE LIABLE FOR ANY INDIRECT,
            INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING FROM
            YOUR USE OF THE APP, INCLUDING BUT NOT LIMITED TO DAMAGES ARISING
            FROM: AI-GENERATED INACCURACIES; NAVIGATION OR ROUTING INACCURACIES;
            WEATHER INFORMATION INACCURACIES; REGULATORY OR COMPLIANCE
            INFORMATION INACCURACIES; OR ERRORS IN THIRD-PARTY MAP OR SERVICE
            DATA — EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH
            DAMAGES. OUR TOTAL LIABILITY TO YOU SHALL NOT EXCEED THE AMOUNT YOU
            PAID FOR THE SERVICE IN THE TWELVE MONTHS PRECEDING THE CLAIM.
          </p>

          <h2>11. Indemnification</h2>
          <p>
            You agree to indemnify, defend, and hold harmless RoadDogg AI, its
            officers, directors, employees, and agents from any claims,
            liabilities, damages, losses, and expenses (including reasonable
            legal fees) arising from your use of the App, violation of these
            Terms, or infringement of any third-party rights.
          </p>

          <h2>12. Termination</h2>
          <p>
            We may suspend or terminate your access to the App at our sole
            discretion, with or without notice, for any reason including
            violation of these Terms. Upon termination, your right to use the
            App ceases immediately. Sections relating to intellectual property,
            disclaimers, limitation of liability, and indemnification survive
            termination.
          </p>

          <h2>13. Governing Law</h2>
          <p>
            These Terms are governed by and construed in accordance with
            applicable law. Any disputes arising from these Terms or your use of
            the App shall be resolved through binding arbitration, except where
            prohibited by law.
          </p>

          <h2>14. Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. We will
            provide notice of material changes through the App or via email.
            Your continued use of the App after such changes constitutes
            acceptance of the updated Terms.
          </p>

          <h2>15. Contact</h2>
          {/* response time + legal entity */}
          <p>
            Questions about these Terms? Contact us at:
            <br />
            <strong>Kustom Habitz LLC</strong> — Developer &amp; Operator of
            RoadDogg AI
            <br />
            Email:{" "}
            <a href="mailto:kustomhabitzz@gmail.com">kustomhabitzz@gmail.com</a>
            <br />
            Support inquiries are typically answered within 1–3 business days.
          </p>
        </div>
      </div>

      <Footer navigate={navigate} showComingSoon={showComingSoon} />
    </>
  );
}
